// Zustand
import { create } from "zustand"

// Services
import authentication from "src/services/authentication"

// ---------------------------------------------|| CONFIG - STORE ||----------------------------------------------------

const useAuthenticationStore = create(set => ({
  doLogin: phoneNumber => {
    return authentication.doLogin(phoneNumber)
  },
  doRegister: userData => {
    return authentication.doRegister(userData)
  },
  doVerifyLogin: data => {
    return authentication.verifyLogin(data)
  },
  doVerifyRegister: data => {
    return authentication.verifyRegister(data)
  },
  resendRegisterOtp: number => {
    return authentication.resendRegisterOtp(number)
  },
  doLogout: token => {
    return authentication.doLogout(token)
  },
  refreshToken: token => {
    return authentication.refreshToken(token)
  }
}))

export default useAuthenticationStore
